export default "__VITE_ASSET__BFaoKoGS__"